import { anonymousRoutes } from '../constants/AppRoutes';

export const isAnonymousRoute = (path: string) => anonymousRoutes.some((route) => path.startsWith(route));
